<script setup lang="ts">
defineOptions({ name: 'ServiceModal' })

defineProps<{
  show: boolean
  title: string
  items: string[]
}>()

defineEmits<{
  (e: 'close'): void
}>()
</script>

<template>
  <Transition name="modal-fade">
    <div v-if="show" class="fixed inset-0 z-[100] flex items-center justify-center">
      <!-- Background overlay -->
      <div class="absolute inset-0 bg-[#FF5A00] opacity-80"></div>
      
      <!-- Modal -->
      <div class="relative w-[calc(100%-32px)] bg-[#222222] text-white overflow-hidden rounded-[10px] font-['HM_Studio_Grotesk']">
        <div class="w-full flex flex-col p-4 pb-8">
          <!-- Header -->
          <div class="flex justify-between items-center mb-4">
            <h2 class="text-base font-normal font-['HM_Studio_Grotesk']">{{ title }}</h2>
            <button 
              @click="$emit('close')" 
              class="text-lg font-['HM_Studio_Grotesk'] opacity-35"
            >
              ×
            </button>
          </div>

          <!-- Content -->
          <ul class="text-base leading-[28px] opacity-35 font-normal">
            <li v-for="(item, i) in items" :key="i">{{ item }}</li>
          </ul>
        </div>
      </div>
    </div>
  </Transition>
</template>

<style scoped>
.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.15s ease;
}

.modal-fade-enter-from,
.modal-fade-leave-to {
  opacity: 0;
}
</style> 